import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Grid,
} from '@material-ui/core';
import moment from 'moment';
import { globalDateEntity } from '../../constants/applicationConstants';

const GroupImportSummary2022 = ({ job }) => {
    return (
        <>
            <Grid item md={12}>
                <TableContainer>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Label</TableCell>
                                <TableCell align="right">Description</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Job Name:</strong>
                                </TableCell>
                                <TableCell align="right">{job.title}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Start Date/Time:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.create_date
                                        ? moment(job.create_date).format(
                                            globalDateEntity.dateTimeFormat,
                                        )
                                        : null}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>End Date/Time:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.modify_date
                                        ? moment(job.modify_date).format(
                                            globalDateEntity.dateTimeFormat,
                                        )
                                        : null}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Import File # of Records:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.total_records
                                        ? job.report.total_records
                                        : 0}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Records Successfully Loaded:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.groups_added
                                        ? job.report.groups_added
                                        : (job.report.records_added ? job.report.records_added : 0)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Records Successfully Updated:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.groups_updated
                                        ? job.report.groups_updated
                                        : (job.report.records_updated ? job.report.records_updated : 0)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Records Not Loaded:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.failed_record ? parseInt(job.report.failed_record) : 0}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>
                                        Records Processed:
                                    </strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.processed_records
                                        ? job.report.processed_records
                                        : 0}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    )
}

export default GroupImportSummary2022;